export enum QueryKeys {
  ALL_MOVIES = "allMovies",
  MOVIE_DETAILS = "movieDetails",
}
